import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CryptService } from 'src/app/services/crypt.service';
import { servicesUrl } from 'src/app/services/servicesUrl';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  hide = true;
  user: string = '';
  pass: string = '';
  loadPage = true;
  constructor(
    private c: CryptService,
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    private router: Router,
    private _url: servicesUrl
  ) {}

  login() {
    this.loadPage = false;
    sessionStorage.removeItem('brnId');
    sessionStorage.removeItem('userbrnId');
    sessionStorage.removeItem('sysid');
    sessionStorage.removeItem('syslang');
    sessionStorage.removeItem('usrFullName');
    sessionStorage.removeItem('usrId');
    sessionStorage.removeItem('brnTitle');
    sessionStorage.removeItem('UserbrnTitle');
    localStorage.removeItem('token');

    if (this.user != '' && this.pass != '') {
      const formData = new FormData();
      formData.append('UserName', this.user);
      formData.append('UserPass', this.pass);
      this.http.post(this._url.url + '/login/auth', formData).subscribe(
        (data) => {
          sessionStorage.setItem('brnId', this.c.Encrypt(data['brnId']));
          sessionStorage.setItem('userbrnId', this.c.Encrypt(data['brnId']));
          sessionStorage.setItem('sysid', this.c.Encrypt(data['sysid']));
          sessionStorage.setItem('syslang', this.c.Encrypt(data['syslang']));
          sessionStorage.setItem(
            'usrFullName',
            this.c.Encrypt(data['usrFullName'])
          );
          sessionStorage.setItem('usrId', this.c.Encrypt(data['usrId']));
          sessionStorage.setItem('brnTitle', this.c.Encrypt(data['brnName']));
          sessionStorage.setItem(
            'UserbrnTitle',
            this.c.Encrypt(data['brnName'])
          );
          localStorage.setItem('token', this.c.Encrypt(data['token']));
          this.loadPage = false;
          this.router.navigateByUrl('dashboard');
        },
        (err) => {
          if (err.status == 404) {
            this._snackBar.open('خطأ فى اسم المستخدم او كلمة المرور', 'حسنا', {
              duration: 3000,
              horizontalPosition: 'right',
              verticalPosition: 'bottom',
            });
          } else {
            this._snackBar.open('خطأ2 فى اسم المستخدم او كلمة المرور', 'حسنا', {
              duration: 3000,
              horizontalPosition: 'right',
              verticalPosition: 'bottom',
            });
          }
          this.loadPage = true;
        }
      );
    } else {
      this._snackBar.open('الرجاء ادخال اسم المستخدم وكلمة المرور', 'حسنا', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'bottom',
      });
      this.loadPage = true;
    }
  }

  ngOnInit(): void {
    this.loadPage = false;
    if (
      sessionStorage.getItem('brnId') != null &&
      sessionStorage.getItem('userbrnId') != null &&
      sessionStorage.getItem('sysid') &&
      sessionStorage.getItem('syslang') &&
      sessionStorage.getItem('usrFullName')
    ) {
      this.router.navigateByUrl('dashboard');
    } else {
      sessionStorage.removeItem('brnId');
      sessionStorage.removeItem('userbrnId');
      sessionStorage.removeItem('sysid');
      sessionStorage.removeItem('syslang');
      sessionStorage.removeItem('usrFullName');
      sessionStorage.removeItem('usrId');
      sessionStorage.removeItem('brnTitle');
      sessionStorage.removeItem('UserbrnTitle');
      localStorage.removeItem('token');
    }

    this.loadPage = true;
  }
}
